(ns ycweb.app.dashboard.planning-css
  (:require
    [rum.core :as rum]))

(rum/defc plan-warnings < rum/static []
  [:div
   ;; This is taken from plan-style.tpl in case you need something easier to copy
   ;; TODO during the UI pass remove this inline css in favor of having it done properly
   [:style
    "td.plan-warning {
        background: #ffd376;
    }
    td.plan-warning-light {
        background: #0094ff;
    }"]
   [:script {:src "https://use.fontawesome.com/b8aea2626d.js"}]])

(rum/defc gross-css < rum/static []
  [:div
   ;; This is taken from plan-style.tpl in case you need something easier to copy
   ;; TODO during the UI pass remove this inline css in favor of having it done properly
   [:style
    "tr.plan-ordered td {
        background: #C8C8C6;
    }
    td.plan-warning {
        background: #ffd376;
    }
    td.plan-warning-light {
        background: #0094ff;
    }
    tr.plan-deleted td {
        background: #ff7972;
    }

    .heading {
        font-size: 18px;
        line-height: 20px;
    }

    .plan-brand-item.first {
        border-top: 1px solid black;
    }

    .fade {
        opacity: 0.5;
    }

    .modalDialog {
        position: fixed;
        font-family: Arial, Helvetica, sans-serif;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: rgba(0,0,0,0.8);
        z-index: 99999;
        opacity:0;
        -webkit-transition: opacity 400ms ease-in;
        -moz-transition: opacity 400ms ease-in;
        transition: opacity 400ms ease-in;
        pointer-events: none;
    }


    .modalDialog:target {
        opacity:1;
        pointer-events: auto;
    }

    .modalDialog > div {
        width: 700px;
        position: relative;
        margin: 10% auto;
        padding: 5px 20px 13px 20px;
        background: #fff;
    }

    .close {
        background: #606061;
        color: #767773;
        line-height: 25px;
        position: absolute;
        text-align: center;
        right: 0px;
        width: 24px;
        text-decoration: none;
        font-weight: bold;
        -webkit-border-radius: 12px;
        -moz-border-radius: 12px;
        border-radius: 12px;
    }

    .close:hover { background: #00d9ff; }

    .clearfix::after {
        content: \"\";
        clear: both;
        display: table;
    }

    .plan-brand-item{
        padding: 7px;
        position: relative;
        white-space:nowrap;
    }
    .plan-brand-item span{
        display:inline-block;
    }

    .deleteitem {
        display:inline-block;
    }

    .processbuttons button{
        margin:15px 10px 5px 10px;
        -moz-border-radius:6px;
        -webkit-border-radius:6px;
        border-radius:6px;
        display:inline-block;
        color:#ffffff;
        font-family:arial;
        font-size:18px;
        font-weight:bold;
        padding:5px 20px;
        text-decoration:none;
        cursor:pointer;
    }

    .itemname a{
        color: black;
    }

    .plan-brand-item span.itemname{
        color: black;
        width: 90px;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .plan-brand:hover {
        background-color: #45c5ff;
        color:white;
    }

    .lastadjustment {
        white-space:nowrap;
    }

    .plan-brand.selected {
        background-color: #45c5ff;
        color:white;
    }

    .plan-brand {
        border: 1px solid black;
        margin: 5px;
        text-align: center;
        float: left;
    }

    .summary-info{
        float:left;
        margin-right: 50px;
    }

    .item-name-status {
        position:relative;
    }

    .status-indicator{
        width:8px;
        height: 8px;
        border-radius: 4px;
        float:left;
        top:50%;
        margin:6px;
    }

    .status-indicator.notready{
        background-color:red;
    }
    .status-indicator.ready{
        background: green;
    }

    .status-indicator.ready.notreadyitems{
        background: -moz-linear-gradient(left, green 0%, green 50%, #ff7c00 51%, #ff7f04 100%); /* FF3.6-15 */
        background: -webkit-linear-gradient(left, green 0%,green 50%,#ff7c00 51%,#ff7f04 100%); /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(to right, green 0%,green 50%,#ff7c00 51%,#ff7f04 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='green', endColorstr='#ff7f04',GradientType=0 ); /* IE6-9 */
    }

    .status-indicator.notready.notreadyitems{
        background: -moz-linear-gradient(left, red 0%, red 50%, #ff7c00 51%, #ff7f04 100%); /* FF3.6-15 */
        background: -webkit-linear-gradient(left, red 0%,red 50%,#ff7c00 51%,#ff7f04 100%); /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(to right, red 0%,red 50%,#ff7c00 51%,#ff7f04 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='red', endColorstr='#ff7f04',GradientType=0 ); /* IE6-9 */
    }
    .status-indicator.ordered{
        background-color:grey;
    }

    .status-update{
        white-space:nowrap;
    }

    .warning {
        color: #FF7F04;
    }

    .tooltip {
        position: relative;
        display: inline-block;
        border-bottom: 1px dotted black;
    }

    .tooltip .tooltiptext {
        visibility: hidden;
        width: 300px;
        background-color: #424242;
        color: #fff;
        text-align: center;
        padding: 5px 0;
        border-radius: 6px;

        bottom: 100%;
        left: 50%;
        margin-left: -60px;

        position: absolute;
        z-index: 1;
    }

    .tooltip:hover .tooltiptext {
        visibility: visible;
    }
    div.divTable {
      border: 3px solid #000000;
      width: 100%;
      text-align: left;
      border-collapse: collapse;
    }
    .divTable.divTable .divTableCell, .divTable.divTable .divTableHead {
      border: 1px solid #000000;
      padding: 5px 4px;
    }
    .divTable.divTable .divTableHeading {
      background: #CFCFCF;
      background: -moz-linear-gradient(top, #dbdbdb 0%, #d3d3d3 66%, #CFCFCF 100%);
      background: -webkit-linear-gradient(top, #dbdbdb 0%, #d3d3d3 66%, #CFCFCF 100%);
      background: linear-gradient(to bottom, #dbdbdb 0%, #d3d3d3 66%, #CFCFCF 100%);
      border-bottom: 3px solid #000000;
    }
    .divTable.divTable .divTableHeading .divTableHead {
      font-size: 15px;
      font-weight: bold;
      color: #000000;
      text-align: center;
    }
    .divTable .tableFootStyle {
      font-size: 14px;
      font-weight: bold;
      color: #000000;
      border-top: 3px solid #000000;
    }
    .divTable .tableFootStyle {
      font-size: 14px;
    }
    .divTable{ display: table; }
    .divTableRow { display: table-row; }
    .divTableHeading { display: table-header-group;}
    .divTableCell, .divTableHead { display: table-cell;}
    .divTableHeading { display: table-header-group;}
    .divTableFoot { display: table-footer-group;}
    .divTableBody { display: table-row-group;}"]
   [:script {:src "https://use.fontawesome.com/b8aea2626d.js"}]])




